import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, SAMPLE_TO_SALE_SCREEN, COMMON, API_CONSTANTS } from '../../global/Constants';
import { ActivityStatusType } from '../../global/Enum';
import './sample-to-sale.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import ActivityHeader from '../common/ActivityHeader';
import Select from 'react-select';
import AddNewImages from '../common/AddNewImages';
import Utilities from '../../global/Utilities';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';


class AddGermination extends Component {
    constructor(props) {
        super(props);
        this.latitude = null;
        this.longitude = null;
        this.state = {
            activity: {},
            germination: '',
            remarks: '',
            images: [],
            deletedImages: [],

            germinationLists: [
                // { value: 0, label: "Good (> 80%)" },
                // { value: 1, label: "Average (79% to 50%)" },
                // { value: 2, label: "Poor (< 50%)" }
            ],
        }
    }

    async componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;

                Utilities.LogPrint("Data:-->", activity);
                if (activity !== undefined && activity !== null) {

                    this.setState({
                        activity: activity
                    }, () => {
                        this.getParams();

                        if (activity?.germinationStage != null) {
                            let germinationStage = activity?.germinationStage;

                            this.setState({
                                germination: this.getGermination(germinationStage.germination),
                                remarks: germinationStage.remark,
                                images: germinationStage.images,
                                deletedImages: germinationStage?.deletedImages
                            });
                        } else {
                            this.setData();
                        }
                    });
                }
                this.getUserLocation();

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }

    }

    getUserLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const coords = position.coords;
                this.latitude = coords.latitude.toFixed(6);
                this.longitude = coords.longitude.toFixed(6);

            }, (error) => {
                Utilities.LogPrint("Error Code = " + error.code + " - " + error.message);
            });
        }
    }

    setData = () => {
        const { activity } = this.state;
        if (activity !== null && activity.activity_status_id !== ActivityStatusType.TO_START) {
            const germinationStage = activity?.data?.history?.stage_eight?.[0];

            if (germinationStage !== undefined && germinationStage !== null) {
                Utilities.LogPrint("GerminationStage:-->", germinationStage);
                this.setState({
                    germination: this.getGermination(germinationStage.germination),
                    remarks: germinationStage.remark,
                    images: germinationStage.images
                });
            }
        }
    }

    getGermination = (germinationId) => {
        const germinationLists = DataProvider.getInstance().getGerminationLists();
        if (germinationLists) {
            const germination = germinationLists.find(item => item.value === germinationId);
            Utilities.LogPrint(`germination:`, germination);
            return germination;
        }
        return "";
    }

    getParams = () => {
        // For Germination
        const germinationLists = DataProvider.getInstance().getGerminationLists();
        //Utilities.LogPrint("GerminationLists:-", germinationLists);
        if (germinationLists.length > 0) {
            this.setState({
                germinationLists: germinationLists
            });
        }
    }

    handleBackButton = () => {
        this.props.history.goBack();
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChange = item => {
        Utilities.LogPrint(`selectedState:`, item);
        this.setState({ germination: item });
    };


    handleAddImages = (images) => {
        Utilities.LogPrint("Images", images);
        this.setState({ images: images });
    }

    handleDeleteImages = (deletedImage) => {
        //Utilities.LogPrint("Images Deleted", deletedImage);
        var deletedImagesArray = this.state.deletedImages.slice();
        deletedImagesArray.push({ image_id: deletedImage.image_id });
        if (deletedImagesArray.length > 0) {
            Utilities.LogPrint("DeletedImages", deletedImagesArray);
            this.setState({ deletedImages: deletedImagesArray });
        }
    }

    handleSaveButton = () => {
        const { germination, remarks, images, deletedImages } = this.state;

        let germinationStage = {
            germination: germination?.value,
            remark: remarks,
            images: images,
            deletedImages: deletedImages,
            latitude: this.latitude,
            longitude: this.longitude
        }

        this.setState(prevState => ({
            activity: { ...prevState.activity, germinationStage: germinationStage }
        }), () => {
            Utilities.LogPrint("germinationStage", this.state.activity);

            if (!this.state.activity?.isEdit) {
                this.props.history.replace({
                    pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                    state: { activity: this.state.activity }
                });
            } else {
                this.props.history.replace({
                    pathname: ALL_ROUTES.EDIT_SAMPLE_TO_SALE,
                    state: { activity: this.state.activity }
                });
            }

            // this.props.history.replace({
            //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
            //     state: { activity: this.state.activity }
            // });
        });
    }


    isFormValid() {
        const { germination } = this.state;
        return !germination;
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { activity, remarks, germinationLists, germination, images } = this.state;
        const { isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                            <ActivityHeader
                                type={4}
                                code={activity?.activity_tag}
                                title={SAMPLE_TO_SALE_SCREEN.GERMINATION}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />

                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBackButton}>Back</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <form>
                                <div className="harvest-details">
                                    <div className="row">
                                        <div className="col-12 col-lg-5 col-md-6">
                                            <div className="form-group">
                                                <label className="w-50 mb-0 font-weight-medium">Germination %</label>
                                                <Select className="max-w-360"
                                                    value={germination}
                                                    onChange={this.handleChange}
                                                    options={germinationLists}
                                                    placeholder="Select Germination"
                                                    isClearable={false} />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="font-weight-medium mt-2">{COMMON.REMARKS} <span className="font-weight-normal"></span></label>
                                                <textarea className="form-control" rows="4" name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <AddNewImages
                                                handleAddImages={this.handleAddImages}
                                                images={images}
                                                handleDeleteImages={this.handleDeleteImages} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn d-md-none" onClick={this.handleBackButton}>{COMMON.BACK}</button>
                            <button className="btn btn-primary w-50 mt-md-4" onClick={this.handleSaveButton} disabled={this.isFormValid()}>{COMMON.SAVE}</button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(AddGermination);